/**
 * Saudi mobile check matching the backend (`common/utils/saudi-phone.util.ts`): 9 digits starting
 * with 5, optionally prefixed by 0, 966, +966 or 00966. Spaces and dashes are ignored.
 * Mobile is the only sign-in identifier for the dashboard and the cashier.
 */
export function isValidSaudiMobile(value: string): boolean {
	const digits = value.replace(/[\s-]/g, "").replace(/^\+/, "");
	if (!/^\d+$/.test(digits)) return false;
	return /^(00966|966|0)?5\d{8}$/.test(digits);
}
